export const jewelleryBeadsLevelTwo = [
    {
        "parentCategoryId": "jewellery_beads",
        "level": 2,
        "name": "Glass Seed Beads",
        "categoryId": "glass_seed_beads"
    },
    {
        "parentCategoryId": "jewellery_beads",
        "level": 2,
        "name": "Crystal Glass Beads",
        "categoryId": "crystal_glass_beads"
    },
    {
        "parentCategoryId": "jewellery_beads",
        "level": 2,
        "name": "Acrylic Beads",
        "categoryId": "acrylic_beads"
    },
    {
        "parentCategoryId": "jewellery_beads",
        "level": 2,
        "name": "Glass Beads",
        "categoryId": "glass_beads"
    },
    {
        "parentCategoryId": "jewellery_beads",
        "level": 2,
        "name": "Real Pearl & Cowrie",
        "categoryId": "real_pearl_n_cowrie"
    },
    {
        "parentCategoryId": "jewellery_beads",
        "level": 2,
        "name": "Semi Precious Beads",
        "categoryId": "semi_precious_beads"
    },
    {
        "parentCategoryId": "jewellery_beads",
        "level": 2,
        "name": "Other Beads",
        "categoryId": "other_beads"
    },

]
